// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lawQ","left":"styles_left__3a0oy"};